// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CurateCard_CurateCard__K6OLq {
  width: 100%;
  height: 100%;
  background: #FAF4F2;
  border-radius: var(--border-radius-large);
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  transition: all 0.2s;
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardText__gl3MW {
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 1;
  justify-content: space-between;
  height: 100%;
  padding: 14px 20px;
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardText__gl3MW .CurateCard_CurateCardTextTitle__OgSpM {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 1;
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardText__gl3MW .CurateCard_CurateCardTextButton__PFgbx {
  display: flex;
  justify-content: end;
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardText__gl3MW h2 {
  font: var(--h5);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 1;
  font-family: var(--font-bodoni);
  font-weight: 700;
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardText__gl3MW h2 span {
  font: var(--h2);
  font-weight: 400;
  font-family: var(--font-alex);
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardImage__tjTvU {
  display: flex;
}
.CurateCard_CurateCard__K6OLq .CurateCard_CurateCardImage__tjTvU img {
  min-height: 250px;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}
.CurateCard_CurateCard__K6OLq:hover {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/DashBordCards/CurateCard.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;AACJ;AACC;EACC,aAAA;EACA,sBAAA;EACA,MAAA;EACA,SAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;AACF;AACE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AACH;AAEE;EACC,aAAA;EACA,oBAAA;AAAH;AAGE;EACC,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,SAAA;EACA,+BAAA;EACA,gBAAA;AADH;AAGG;EACC,eAAA;EACA,gBAAA;EACA,6BAAA;AADJ;AAMC;EACC,aAAA;AAJF;AAMQ;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAJZ;AAQI;EACI,2CAAA;AANR","sourcesContent":[".CurateCard {\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #FAF4F2;\r\n    border-radius: var(--border-radius-large);\r\n    overflow: hidden;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    gap: 10px;\r\n    transition: all 0.2s;\r\n\r\n\t.CurateCardText {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 0;\r\n\t\tflex: 1;\r\n\t\tjustify-content: space-between;\r\n\t\theight: 100%;\r\n\t\tpadding: 14px 20px;\r\n\r\n\t\t.CurateCardTextTitle {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: center;\r\n\t\t\talign-items: center;\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\r\n\t\t.CurateCardTextButton {\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: end;\r\n\t\t}\r\n\r\n\t\th2 {\r\n\t\t\tfont: var(--h5);\r\n\t\t\ttext-align: center;\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-direction: column;\r\n\t\t\tgap: 0;\r\n\t\t\tflex: 1;\r\n\t\t\tfont-family: var(--font-bodoni);\r\n\t\t\tfont-weight: 700;\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--h2);\r\n\t\t\t\tfont-weight: 400;\r\n\t\t\t\tfont-family: var(--font-alex);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.CurateCardImage {\r\n\t\tdisplay: flex;\r\n\r\n        img {\r\n            min-height: 250px;\r\n            height: 100%;\r\n            width: 100%;\r\n            object-fit: cover;\r\n            object-position: center;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CurateCard": `CurateCard_CurateCard__K6OLq`,
	"CurateCardText": `CurateCard_CurateCardText__gl3MW`,
	"CurateCardTextTitle": `CurateCard_CurateCardTextTitle__OgSpM`,
	"CurateCardTextButton": `CurateCard_CurateCardTextButton__PFgbx`,
	"CurateCardImage": `CurateCard_CurateCardImage__tjTvU`
};
export default ___CSS_LOADER_EXPORT___;
